// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  about: dynamic(() => import("./About")),
  banner_image: dynamic(() => import("./BannerImage")),
  contact_us: dynamic(() => import("./ContactUs")),
  footer_info: dynamic(() => import("./FooterInfo")),
  footer_nav_items: dynamic(() => import("./FooterNavItems")),
  homepage_intro: dynamic(() => import("./HomepageIntro")),
  legal_info: dynamic(() => import("./LegalInfo")),
  logo: dynamic(() => import("./Logo")),
  nav_items: dynamic(() => import("./NavItems")),
  project_info: dynamic(() => import("./ProjectInfo")),
  projects: dynamic(() => import("./Projects")),
  projects_list: dynamic(() => import("./ProjectsList")),
  testimonials: dynamic(() => import("./Testimonials")),
  text: dynamic(() => import("./Text")),
};
